import { singletonHook } from 'react-singleton-hook';
import useArtifactInfoService from '../artifactInfoService';
import type { ArtifactsInfoResponse } from '../types';
import useCreateArtifactsInfoReceiver, { filterValidArtifactIds } from './createArtifactsInfoReceiver';

type CandidateArtifactsInfoReceiver = {
  hookLoading: boolean;
  collectCandidateArtifactsData: (initialAttachmentsIds: string[]) => Promise<ArtifactsInfoResponse['artifacts']>;
};

const initState: CandidateArtifactsInfoReceiver = {
  hookLoading: true,
  collectCandidateArtifactsData: async () => ({}),
};

const useCandidateArtifactsInfoReceiverImpl = () => {
  const { getCandidateArtifactsInfo } = useArtifactInfoService();

  const collectCandidateArtifactsData = useCreateArtifactsInfoReceiver({
    getArtifactsInfo: getCandidateArtifactsInfo,
    getBatchIds: filterValidArtifactIds,
  });

  return {
    hookLoading: false,
    collectCandidateArtifactsData,
  };
};

const useCandidateArtifactsInfoReceiver = singletonHook(initState, useCandidateArtifactsInfoReceiverImpl);

export default useCandidateArtifactsInfoReceiver;
